export default "__VITE_ASSET__BzzmagKO__"